module.exports = __webpack_public_path__ + "static/media/S-task14_nodeLink.dadf2a19.png";